/*
  NBV2 About Market (sections/nbv2-about-market.liquid)

  Once the cards scroll into view, activates each stat card in turn: the CSS
  raises the pin and fades the card in (or slides it in from the right when
  stacked), and this file counts the card's number up as the fade starts. Counter parsing mirrors assets/nb-about-hero.js.
*/
(function () {
  'use strict';

  var CARD_STAGGER = 600;
  var COUNTER_DURATION = 1400;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  // "$ 380B" -> { prefix: '$ ', number: 380, suffix: 'B', decimals: 0 }
  function parseStatValue(text) {
    var match = text.match(/^([^0-9]*)(\d+(?:\.(\d+))?)(.*)$/);
    if (!match) return null;
    return {
      prefix: match[1],
      number: parseFloat(match[2]),
      decimals: match[3] ? match[3].length : 0,
      suffix: match[4]
    };
  }

  function format(parsed, value) {
    return parsed.prefix + value.toFixed(parsed.decimals) + parsed.suffix;
  }

  function countUp(el) {
    var original = el.getAttribute('data-nbv2-am-value') || el.textContent.trim();
    var parsed = parseStatValue(original);
    if (!parsed) return;

    var start = null;
    el.textContent = format(parsed, 0);

    function step(ts) {
      if (start === null) start = ts;
      var progress = Math.min((ts - start) / COUNTER_DURATION, 1);
      if (progress < 1) {
        el.textContent = format(parsed, easeOutCubic(progress) * parsed.number);
        requestAnimationFrame(step);
      } else {
        el.textContent = original;
      }
    }

    requestAnimationFrame(step);
  }

  // The card fades in after the pin rises (desktop) or slides in straight away (stacked);
  // start counting when its fade does.
  function fadeDelay(card) {
    if (!card) return 0;
    var delay = getComputedStyle(card).transitionDelay.split(',')[0].trim();
    var ms = parseFloat(delay) || 0;
    return delay.indexOf('ms') !== -1 ? ms : ms * 1000;
  }

  function activate(section) {
    var wraps = section.querySelectorAll('.nbv2-about-market__card-wrap');

    wraps.forEach(function (wrap, index) {
      var value = wrap.querySelector('.nbv2-about-market__value');

      if (reducedMotion.matches) {
        wrap.classList.add('is-active');
        return;
      }

      if (value) {
        var parsed = parseStatValue(value.getAttribute('data-nbv2-am-value') || '');
        if (parsed) value.textContent = format(parsed, 0);
      }

      setTimeout(function () {
        wrap.classList.add('is-active');
        if (!value) return;
        setTimeout(function () {
          countUp(value);
        }, fadeDelay(wrap.querySelector('.nbv2-about-market__card')));
      }, index * CARD_STAGGER);
    });
  }

  function init(root) {
    var sections = (root || document).querySelectorAll('[data-nbv2-about-market]');

    sections.forEach(function (section) {
      if (section.dataset.nbv2AmInit === 'true') return;
      section.dataset.nbv2AmInit = 'true';

      if (!('IntersectionObserver' in window)) {
        activate(section);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.disconnect();
            activate(section);
          });
        },
        { threshold: 0.35 }
      );

      // Watch the cards themselves so the reveal starts when they are on screen.
      observer.observe(
        section.querySelector('.nbv2-about-market__cards') ||
          section.querySelector('.nbv2-about-market__stage') ||
          section
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
